// Logic for form adding image set
$(document).ready(function(){
  if($('form#add-collection').length){
    if($('form#add-collection input[name="include_in_published_books"]').length){
      if($('form#add-collection input[name="include_in_published_books"]:checked').length){
        $('.image-set__include-pb').slideDown();
        $('.image-set__include-pb input[type="text"]').prop('required', true);
      } else {
        $('.image-set__include-pb input[type="text"]').prop('required', false);
        $('.image-set__include-pb').slideUp();
      }
      $('form#add-collection input[name="include_in_published_books"]').change(function(){
        if($(this).is( ":checked" )){
          $('.image-set__include-pb').slideDown();
          $('.image-set__include-pb input[type="text"]').prop('required', true);
        } else {
          $('.image-set__include-pb input[type="text"]').prop('required', false);
          $('.image-set__include-pb').slideUp();
        }
      });
    }
  }
});